import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-iban-pipe-page-ui',
    templateUrl: './bb-iban-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class IbanPageComponent {}
